import styled, { css } from 'styled-components';
import { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import { lastminuteDealsGradientOnText } from '@/app/common/components/Promotions/styled.ts';
import { promotionColors } from '../styled';

const productInfoOverlayStyles = css`
  display: inline-block;
  margin-right: 8px;
`;

const productInfoMobileStyles = css`
  display: inline-block;
  margin-right: 8px;
`;

export const ProductInfo = styled.div<{
  isOverlay: boolean;
  hasLongPrice: boolean;
}>`
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  font-size: ${({ theme }) => theme.kallisto.font.size['150']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['200']};
  margin-bottom: 4px;

  ${({ isOverlay, hasLongPrice }) => isOverlay && !hasLongPrice && productInfoOverlayStyles};

  @media (max-width: 767px) {
    ${({ hasLongPrice }) => !hasLongPrice && productInfoMobileStyles}
  }
`;

export const PriceTotalAmount = styled.div`
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  font-size: ${({ theme }) => theme.kallisto.font.size['150']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['200']};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  text-align: right;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  letter-spacing: 0.01em;
`;

export const PriceUnit = styled.div<{
  promotionType: PROMOTION_TYPES | null;
  isOverlay: boolean;
  isWhiteLabel: boolean;
  hasLongPrice: boolean;
  lastMinuteDeals: boolean;
}>`
  ${({ theme }) => theme.kallisto.mixins.font('Caption')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  margin-bottom: 4px;
  display: inline-block;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ isOverlay }) =>
    isOverlay &&
    css`
      display: inline;
    `};

  ${promotionColors};
`;

export const PriceDiscount = styled.span<{
  promotionType: PROMOTION_TYPES | null;
  isWhiteLabel?: boolean;
  hasLongPrice: boolean;
  lastMinuteDeals: boolean;
}>`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  font-style: normal;
  display: inline-block;
  height: 20px;
  text-decoration-line: line-through;
  text-decoration-style: solid;
  text-decoration-color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  padding: 0;
  text-decoration-thickness: 1px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};

  ${({ hasLongPrice }) =>
    hasLongPrice &&
    css`
      display: block;
    `};

  svg {
    margin-right: 2px;
    margin-bottom: 4px;
    vertical-align: middle;
    pointer-events: none;
    position: relative;
    z-index: 1;
  }
`;

export const myPriceDiscountPercentageStyles = css`
  background-color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[100]};
  color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[700]};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`;

export const PriceDiscountPercentage = styled.div<{ isOverlay: boolean; isMobile: boolean }>`
  padding: 4px 8px;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  ${myPriceDiscountPercentageStyles};
  margin-top: ${({ isOverlay, isMobile }) => (isOverlay || isMobile ? 0 : `4px`)};
`;

const priceAmountOverlay = css`
  font-size: 19px;
  font-weight: 700;
  line-height: 26px;
  text-align: right;
`;

export const PriceAmount = styled.span<{
  promotionType: PROMOTION_TYPES | null;
  isWhiteLabel?: boolean;
  isOverlay?: boolean;
  lastMinuteDeals: boolean;
}>`
  display: inline-block;
  ${({ theme }) => theme.kallisto.mixins.font('Title3')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  ${promotionColors};

  ${PriceDiscount} + & {
    margin-left: 8px;
  }

  ${({ isOverlay }) => isOverlay && priceAmountOverlay}
  ${({ promotionType, lastMinuteDeals }) =>
    promotionType === PROMOTION_TYPES.FLASH_SALES && lastMinuteDeals && lastminuteDealsGradientOnText};
`;

export const PriceDetailsContainer = styled.div`
  text-align: right;
`;

export const PriceDetailsWrapper = styled.div`
  position: relative;
`;

export const TaxesIncludedBlock = styled.div<{ $isOverlay: boolean }>`
  border-radius: 8px;
  text-align: right;
  cursor: pointer;

  ${({ $isOverlay, theme }) =>
    !$isOverlay &&
    css`
      background-color: ${theme.kallisto.color.background.static.backgroundLayer01};
      color: ${theme.kallisto.color.text.static.textPrimary};
      padding: 8px;
      margin-top: 4px;
    `}
`;
